// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21AEG","top":"styles_top__39nMj","left":"styles_left__2O6iX","description":"styles_description__1cSCR"};